import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "009_create_receipts_owner_table",
  version: "1.4.5",
  ignoreErrors: [
    "no such table: accounting_payments",
    "duplicate column name",
  ],
  sql: `
CREATE TABLE IF NOT EXISTS \`accounting_receipts\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`payment_no\` text NOT NULL UNIQUE,
  \`company_id\` text NOT NULL,
  \`branch_id\` text,
  \`payment_type\` text NOT NULL DEFAULT 'receive',
  \`party_type\` text NOT NULL DEFAULT 'customer',
  \`party_id\` text NOT NULL,
  \`payment_date\` text NOT NULL,
  \`payment_method\` text NOT NULL,
  \`amount\` real NOT NULL,
  \`reference_no\` text,
  \`bank_account_id\` text,
  \`receipt_url\` text,
  \`doc_status\` integer NOT NULL DEFAULT 0,
  \`status\` text NOT NULL DEFAULT 'draft',
  \`currency_code\` text DEFAULT 'THB',
  \`exchange_rate\` real DEFAULT 1,
  \`remarks\` text,
  \`reference_module\` text,
  \`reference_doctype\` text,
  \`reference_id\` text,
  \`created_by\` text,
  \`created_at\` text NOT NULL,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  CONSTRAINT \`accounting_receipts_owner_chk\`
    CHECK(\`payment_type\` = 'receive' AND \`party_type\` = 'customer')
);

ALTER TABLE \`accounting_receipts\` ADD COLUMN \`payment_purpose\` text NOT NULL DEFAULT 'invoice_payment';
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`advance_account_id\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`wht_type_id\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`wht_rate\` real NOT NULL DEFAULT 0;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`wht_amount\` real NOT NULL DEFAULT 0;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`wht_tax_period\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`vat_at_payment_amount\` real NOT NULL DEFAULT 0;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`vat_at_payment_account_id\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`vat_at_payment_period\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`payment_channel\` text NOT NULL DEFAULT 'cash';
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`bank_account_master_id\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`bank_transfer_reference\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`cheque_id\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`cheque_no\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`cheque_date\` text;
ALTER TABLE \`accounting_receipts\` ADD COLUMN \`cheque_bank_name\` text;

INSERT OR IGNORE INTO \`accounting_receipts\` (
  \`id\`,
  \`payment_no\`,
  \`company_id\`,
  \`branch_id\`,
  \`payment_type\`,
  \`party_type\`,
  \`party_id\`,
  \`payment_date\`,
  \`payment_method\`,
  \`amount\`,
  \`reference_no\`,
  \`bank_account_id\`,
  \`receipt_url\`,
  \`doc_status\`,
  \`status\`,
  \`currency_code\`,
  \`exchange_rate\`,
  \`remarks\`,
  \`reference_module\`,
  \`reference_doctype\`,
  \`reference_id\`,
  \`created_by\`,
  \`created_at\`,
  \`updated_at\`,
  \`updated_by\`,
  \`deleted_at\`,
  \`deleted_by\`
)
SELECT
  \`id\`,
  \`payment_no\`,
  \`company_id\`,
  \`branch_id\`,
  'receive',
  'customer',
  \`party_id\`,
  \`payment_date\`,
  \`payment_method\`,
  \`amount\`,
  \`reference_no\`,
  \`bank_account_id\`,
  \`receipt_url\`,
  \`doc_status\`,
  \`status\`,
  \`currency_code\`,
  \`exchange_rate\`,
  \`remarks\`,
  \`reference_module\`,
  \`reference_doctype\`,
  \`reference_id\`,
  \`created_by\`,
  \`created_at\`,
  \`updated_at\`,
  \`updated_by\`,
  \`deleted_at\`,
  \`deleted_by\`
FROM \`accounting_payments\`
WHERE \`payment_type\` = 'receive';

CREATE INDEX IF NOT EXISTS \`rec_company_status_idx\`
  ON \`accounting_receipts\` (\`company_id\`, \`status\`, \`payment_date\`);

CREATE INDEX IF NOT EXISTS \`rec_company_party_idx\`
  ON \`accounting_receipts\` (\`company_id\`, \`party_type\`, \`party_id\`);

CREATE INDEX IF NOT EXISTS \`rec_company_branch_idx\`
  ON \`accounting_receipts\` (\`company_id\`, \`branch_id\`);

CREATE INDEX IF NOT EXISTS \`rec_company_bank_master_idx\`
  ON \`accounting_receipts\` (\`company_id\`, \`bank_account_master_id\`);

CREATE INDEX IF NOT EXISTS \`rec_company_cheque_idx\`
  ON \`accounting_receipts\` (\`company_id\`, \`cheque_id\`);

CREATE TRIGGER IF NOT EXISTS \`accounting_receipts_owner_insert_guard\` BEFORE INSERT ON \`accounting_receipts\` FOR EACH ROW WHEN NEW.\`payment_type\` <> 'receive' OR NEW.\`party_type\` <> 'customer' BEGIN SELECT RAISE(ABORT, 'accounting_receipts owner discriminator violation'); END;

CREATE TRIGGER IF NOT EXISTS \`accounting_receipts_owner_update_guard\` BEFORE UPDATE OF \`payment_type\`, \`party_type\` ON \`accounting_receipts\` FOR EACH ROW WHEN NEW.\`payment_type\` <> 'receive' OR NEW.\`party_type\` <> 'customer' BEGIN SELECT RAISE(ABORT, 'accounting_receipts owner discriminator violation'); END;
  `.trim(),
};
